
<h3 mat-dialog-title>{{title}}</h3>
<mat-dialog-content>
  <form [formGroup]="dialogForm">
    <mat-form-field  appearance="outline" class="w-100 mt-3">
      <mat-label>Client/Entity Name</mat-label>
      <input matInput placeholder="Client/Entity Name" formControlName="name" minlength="2" required autocomplete="off">
      @if (dialogForm.controls.name.errors?.required) {
        <mat-error>Name is required</mat-error>
      }
      @if (dialogForm.controls.name.hasError('minlength')) {
        <mat-error>Name isn't long enough, minimum of 2 characters</mat-error>
      }
      @if (dialogForm.controls.name.hasError('maxlength')) {
        <mat-error>Name is too long, maximum of 256 characters</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row justify-end items-center mt-3 p-2">
    <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button color="primary" class="dialog-btn" (click)="onConfirmClick()" [disabled]='!dialogForm.valid'><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>


